import React, {ReactElement} from "react";
import {Route} from "react-router-dom";
import WorldPage from "../../../pages/chase/story/world/WorldPage";
import WorldSectionPage from "../../../pages/chase/story/world/section/WorldSectionPage";
import BestiaryPage from "../../../pages/chase/story/world/bestiary/BestiaryPage";
import BotanaryPage from "../../../pages/chase/story/world/botanary/BotanaryPage";
import GeographyPage from "../../../pages/chase/story/world/geography/GeographyPage";
import HistoryPage from "../../../pages/chase/story/world/history/HistoryPage";
import CreationHistoryPage from "../../../pages/chase/story/world/history/ages/CreationHistoryPage";
import DraconicHistoryPage from "../../../pages/chase/story/world/history/ages/DraconicHistoryPage";
import IronHistoryPage from "../../../pages/chase/story/world/history/ages/IronHistoryPage";
import RebellionHistoryPage from "../../../pages/chase/story/world/history/ages/RebellionHistoryPage";
import MagicalHistoryPage from "../../../pages/chase/story/world/history/ages/MagicalHistoryPage";
import EmpiricalHistoryPage from "../../../pages/chase/story/world/history/ages/EmpiricalHistoryPage";
import CrusadeHistoryPage from "../../../pages/chase/story/world/history/ages/CrusadeHistoryPage";
import FeudalHistoryPage from "../../../pages/chase/story/world/history/ages/FeudalHistoryPage";
import CataclysmicHistoryPage from "../../../pages/chase/story/world/history/ages/CataclysmicHistoryPage";
import RecoveryHistoryPage from "../../../pages/chase/story/world/history/ages/RecoveryHistoryPage";
import ReemergenceHistoryPage from "../../../pages/chase/story/world/history/ages/ReemergenceHistoryPage";
import RenaissanceHistoryPage from "../../../pages/chase/story/world/history/ages/RenaissanceHistoryPage";
import ExpansionHistoryPage from "../../../pages/chase/story/world/history/ages/ExpansionHistoryPage";
import EnlightenedHistoryPage from "../../../pages/chase/story/world/history/ages/EnlightenedHistoryPage";
import IndustrialHistoryPage from "../../../pages/chase/story/world/history/ages/IndustrialHistoryPage";
import MachinationHistoryPage from "../../../pages/chase/story/world/history/ages/MachinationHistoryPage";
import ModernHistoryPage from "../../../pages/chase/story/world/history/ages/ModernHistoryPage";
import MagicPage from "../../../pages/chase/story/world/magic/MagicPage";
import MagicSchoolsPage from "../../../pages/chase/story/world/magic/schools/MagicSchoolsPage";
import MagicElementsPage from "../../../pages/chase/story/world/magic/elements/MagicElementsPage";
import MagicClassesPage from "../../../pages/chase/story/world/magic/classes/MagicClassesPage";
import MagicItemsPage from "../../../pages/chase/story/world/magic/items/MagicItemsPage";
import MagicAmuletPage from "../../../pages/chase/story/world/magic/items/subpages/MagicAmuletPage";
import MagicBulletguardPage from "../../../pages/chase/story/world/magic/items/subpages/MagicBulletguardPage";
import MagicMageTechPage from "../../../pages/chase/story/world/magic/items/subpages/MagicMageTechPage";
import MagicRunestonePage from "../../../pages/chase/story/world/magic/items/subpages/MagicRunestonePage";
import MagicTomePage from "../../../pages/chase/story/world/magic/items/subpages/MagicTomePage";
import MagicWardPage from "../../../pages/chase/story/world/magic/items/subpages/MagicWardPage";
import MagicAfflictionsPage from "../../../pages/chase/story/world/magic/afflictions/MagicAfflictionsPage";
import LanguagesPage from "../../../pages/chase/story/world/languages/LanguagesPage";
import CommonLanguagePage from "../../../pages/chase/story/world/languages/common/CommonLanguagePage";
import ReligionPage from "../../../pages/chase/story/world/religion/ReligionPage";
import PantheonPage from "../../../pages/chase/story/world/religion/pantheon/PantheonPage";
import MythologyPage from "../../../pages/chase/story/world/religion/mythology/MythologyPage";
import MythOfTheSixSistersPage from "../../../pages/chase/story/world/religion/mythology/myths/MythOfTheSixSistersPage";
import MythOfTheSunAndMoonPage from "../../../pages/chase/story/world/religion/mythology/myths/MythOfTheSunAndMoonPage";
import WorldBestiarySubsectionPage
    from "../../../pages/chase/story/world/bestiary/subsection/WorldBestiarySubsectionPage";

class WorldRouter {

    public static getRoutes(): ReactElement {
        return (
            <>
                <Route path="world">
                    <Route index element={<WorldPage/>}/>
                    <Route path="bestiary">
                        <Route index element={<BestiaryPage/>}/>
                        <Route path=":subsection">
                            <Route index element={<WorldBestiarySubsectionPage/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage section="bestiary"/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="botanary">
                        <Route index element={<BotanaryPage/>}/>
                        <Route path=":subsection">
                            <Route index element={<WorldSectionPage section="botanary"/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage section="botanary"/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="geography">
                        <Route index element={<GeographyPage/>}/>
                    </Route>
                    <Route path="history">
                        <Route index element={<HistoryPage/>}/>
                        <Route path="creation-age" element={<CreationHistoryPage/>}/>
                        <Route path="draconic-age" element={<DraconicHistoryPage/>}/>
                        <Route path="iron-age" element={<IronHistoryPage/>}/>
                        <Route path="rebellion-age" element={<RebellionHistoryPage/>}/>
                        <Route path="magical-age" element={<MagicalHistoryPage/>}/>
                        <Route path="empirical-age" element={<EmpiricalHistoryPage/>}/>
                        <Route path="crusade-age" element={<CrusadeHistoryPage/>}/>
                        <Route path="feudal-age" element={<FeudalHistoryPage/>}/>
                        <Route path="cataclysmic-age" element={<CataclysmicHistoryPage/>}/>
                        <Route path="recovery-age" element={<RecoveryHistoryPage/>}/>
                        <Route path="reemergence-age" element={<ReemergenceHistoryPage/>}/>
                        <Route path="renaissance-age" element={<RenaissanceHistoryPage/>}/>
                        <Route path="expansion-age" element={<ExpansionHistoryPage/>}/>
                        <Route path="enlightened-age" element={<EnlightenedHistoryPage/>}/>
                        <Route path="industrial-age" element={<IndustrialHistoryPage/>}/>
                        <Route path="machination-age" element={<MachinationHistoryPage/>}/>
                        <Route path="modern-age" element={<ModernHistoryPage/>}/>
                    </Route>
                    <Route path="magic">
                        <Route index element={<MagicPage/>}/>
                        <Route path="afflictions">
                            <Route index element={<MagicAfflictionsPage/>}/>
                        </Route>
                        <Route path="classes">
                            <Route index element={<MagicClassesPage/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage section="magic" subsection="classes"/>}/>
                            </Route>
                        </Route>
                        <Route path="elements">
                            <Route index element={<MagicElementsPage/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage section="magic" subsection="elements"/>}/>
                            </Route>
                        </Route>
                        <Route path="items">
                            <Route index element={<MagicItemsPage/>}/>
                            <Route path="amulet" element={<MagicAmuletPage/>}/>
                            <Route path="bulletguard" element={<MagicBulletguardPage/>}/>
                            <Route path="mage-tech" element={<MagicMageTechPage/>}/>
                            <Route path="runestone" element={<MagicRunestonePage/>}/>
                            <Route path="tome" element={<MagicTomePage/>}/>
                            <Route path="ward" element={<MagicWardPage/>}/>
                        </Route>
                        <Route path="schools">
                            <Route index element={<MagicSchoolsPage/>}/>
                        </Route>
                    </Route>
                    <Route path="languages">
                        <Route index element={<LanguagesPage/>}/>
                        <Route path="common">
                            <Route index element={<CommonLanguagePage/>}/>
                        </Route>
                    </Route>
                    <Route path="religion">
                        <Route index element={<ReligionPage/>}/>
                        <Route path="pantheon">
                            <Route index element={<PantheonPage/>}/>
                        </Route>
                        <Route path="mythology">
                            <Route index element={<MythologyPage/>}/>
                            <Route path="myth-of-the-six-sisters" element={<MythOfTheSixSistersPage/>}/>
                            <Route path="myth-of-the-sun-and-moon" element={<MythOfTheSunAndMoonPage/>}/>
                        </Route>
                    </Route>
                </Route>
            </>
        );
    }
}

export default WorldRouter;